import {utils} from '@wallaby-ui/core';
import {find, first} from 'lodash';

import {File} from './file';

export class CaseDocuments {
  static initResultFiles(rawDataFiles) {
    const resultDocuments = [];
    if (rawDataFiles) {
      rawDataFiles.forEach((file) => {
        resultDocuments.push(new File(file));
      });
    }
    return resultDocuments;
  }

  constructor(rawData = []) {
    this.rawData = [...rawData];
    this.resultFiles = [];
    this.loaded = false;
    if (this.rawData) {
      this.resultFiles = CaseDocuments.initResultFiles(this.rawData);
      this.loaded = true;
    }
  }

  getResultFiles() {
    return this.resultFiles;
  }

  getResultFile(docId) {
    return find(this.getResultFiles(), (doc) =>
      utils.StringUtils.isEqualNumber(doc.getId(), docId)
    );
  }

  getFirstResultFile() {
    return first(this.getResultFiles());
  }

  isLoaded() {
    return this.loaded;
  }
}

export default {CaseDocuments};
